const arr = [
    // 通用任务列表
    {
        path: '/mission/list',
        component: () => import(/* webpackChunkName:"missionList"*/'@/pages/mission/index.vue'),
        name: 'missionList',
        meta: {
            title: '任务中心',
        },
    },
];
export default arr;
